
export default function initializeCharts() {
    am4core.ready(function () {
        am4core.options.autoSetClassName = true;
        // Themes begin
        am4core.useTheme(am4themes_animated);
        // Themes end

        initOverviewChart();
        initTimelineChart();
    }); // end am4core.ready()

    function initTimelineChart() {
        var overViewChart = am4core.create("chart-timeline", am4charts.XYChart);
        overViewChart.maskBullets = false;
        overViewChart.logo.disabled = true;
        // Set cell size in pixels
        let cellSize = 80;
        overViewChart.events.on("datavalidated", function (ev) {
            // Get objects of interest
            let overViewChart = ev.target;
            let categoryAxis = overViewChart.yAxes.getIndex(0);

            const result = overViewChart.data.reduce((total, value) => {
                total[value['feature']] = (total[value['feature']] || 0) + 1;
                return total;
            }, {});

            // Calculate how we need to adjust chart height
            let adjustHeight = Object.keys(result).length * cellSize /*- categoryAxis.pixelHeight*/;

            // get current chart height
            let targetHeight = /*overViewChart.pixelHeight +*/ 100 + adjustHeight;
            //console.log('SETTING HEIGHT', targetHeight);
            // Set it on chart's container
            overViewChart.svgContainer.htmlElement.style.height = targetHeight + "px";
        });

        var xAxis = overViewChart.xAxes.push(new am4charts.CategoryAxis());
        var yAxis = overViewChart.yAxes.push(new am4charts.CategoryAxis());

        yAxis.dataFields.category = "feature";
        xAxis.renderer.minGridDistance = 10;
        xAxis.dataFields.category = "timeInfo";

        xAxis.renderer.grid.template.disabled = true;
        //xAxis.dy = 20;
        //yAxis.renderer.grid.template.disabled = true;
        xAxis.renderer.axisFills.template.disabled = true;
        //yAxis.renderer.axisFills.template.disabled = true;
        //yAxis.renderer.ticks.template.disabled = true;
        xAxis.renderer.ticks.template.disabled = true;

        yAxis.renderer.grid.template.strokeOpacity = 0.05;
        //yAxis.renderer.grid.template.stroke = am4core.color("#A0CA92");
        yAxis.renderer.grid.template.strokeWidth = 10;
        yAxis.renderer.grid.template.strokeLinecap = 'round';
        yAxis.renderer.labels.template.fontSize = '12px';
        yAxis.renderer.labels.template.marginRight = 10;
        yAxis.renderer.labels.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        yAxis.renderer.labels.template.events.on("hit", function (e) {
            const cat = e.target.dataItem.category;
            const vm = ko.dataFor($('#moods-chart')[0]);

            vm.showDetailMoods(cat);

            for (const yAxis of overViewChart.yAxes) {
                for (const di of yAxis.dataItems) {

                    if (di.label.background) {
                        di.label.background.fill = am4core.color('white');
                    }
                }
            }

            e.target.background.fill = am4core.color('yellow');
        });
        let label = yAxis.renderer.labels.template;
        label.wrap = true;
        label.maxWidth = 180;

        yAxis.renderer.inversed = true;

        var series = overViewChart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryY = "feature";
        series.dataFields.categoryX = "timeInfo";
        series.dataFields.customValue = "rating";
        series.dataFields.value = "rating";
        series.columns.template.disabled = true;
        series.sequencedInterpolation = true;
        series.maskBullets = false;
        //series.defaultState.transitionDuration = 3000;

        var bullet = series.bullets.push(new am4core.Circle());
        bullet.tooltipText = "Average rating of {feature}";
        //bullet.strokeWidth = 3;
        bullet.stroke = am4core.color("#ffffff");
        //bullet.strokeOpacity = 0;
        bullet.strokeOpacity = 1;
        bullet.strokeWidth = 2;
        //bullet.fillOpacity = 0.7;

        bullet.adapter.add("fill", function (fill, target) {
            if (target.dataItem) {
                if (target.dataItem.customValue >= 8) {
                    return am4core.color("#a8df65")
                }
                else if (target.dataItem.customValue >= 6) {
                    return am4core.color("#f6f578")
                }
                else if (target.dataItem.customValue >= 4) {
                    return am4core.color("#fbe555")
                }
                else if (target.dataItem.customValue >= 2) {
                    return am4core.color("#f8b500")
                }
                else {
                    return am4core.color("#eb4559");
                }
            }
            return fill;
        });

        var hoverState = bullet.states.create("hover");
        hoverState.properties.fillOpacity = 1;
        //hoverState.properties.strokeOpacity = 1;

        series.heatRules.push({
            property: "radius",
            target: bullet,
            min: 8,
            max: 30
        });

        bullet.hiddenState.properties.scale = 0.01;
        bullet.hiddenState.properties.opacity = 1;

        var hoverState = bullet.states.create("hover");
        hoverState.properties.strokeOpacity = 1;

        document.addEventListener('refresh_chart_timeline', (e) => {
            selectDataset(e.detail);
        });

        function selectDataset(data) {
            overViewChart.invalidateRawData();
            overViewChart.data = data;
            series.appear();
        }
    }

    function initOverviewChart() {
        var overViewChart = am4core.create("chart", am4charts.XYChart);
        overViewChart.maskBullets = false;
        overViewChart.logo.disabled = true;
        // Set cell size in pixels
        let cellSize = 40;
        overViewChart.events.on("datavalidated", function (ev) {
            // Get objects of interest
            let overViewChart = ev.target;
            let categoryAxis = overViewChart.yAxes.getIndex(0);

            const result = overViewChart.data.reduce((total, value) => {
                total[value['feature']] = (total[value['feature']] || 0) + 1;
                return total;
            }, {});

            // Calculate how we need to adjust chart height
            let adjustHeight = Object.keys(result).length * cellSize /*- categoryAxis.pixelHeight*/;

            // get current chart height
            let targetHeight = /*overViewChart.pixelHeight +*/100 + adjustHeight;

            // Set it on chart's container
            overViewChart.svgContainer.htmlElement.style.height = targetHeight + "px";
        });

        var xAxis = overViewChart.xAxes.push(new am4charts.CategoryAxis());
        var yAxis = overViewChart.yAxes.push(new am4charts.CategoryAxis());

        yAxis.dataFields.category = "feature";
        xAxis.renderer.minGridDistance = 10;
        xAxis.dataFields.category = "rating";

        xAxis.renderer.grid.template.disabled = true;
        //xAxis.dy = 20;
        //yAxis.renderer.grid.template.disabled = true;
        xAxis.renderer.axisFills.template.disabled = true;
        //yAxis.renderer.axisFills.template.disabled = true;
        //yAxis.renderer.ticks.template.disabled = true;
        xAxis.renderer.ticks.template.disabled = true;

        yAxis.renderer.grid.template.strokeOpacity = 0.05;
        //yAxis.renderer.grid.template.stroke = am4core.color("#A0CA92");
        yAxis.renderer.grid.template.strokeWidth = 10;
        yAxis.renderer.grid.template.strokeLinecap = 'round';
        yAxis.renderer.labels.template.fontSize = '12px';
        yAxis.renderer.labels.template.marginRight = 10;
        yAxis.renderer.labels.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        yAxis.renderer.labels.template.events.on("hit", function (e) {
            const cat = e.target.dataItem.category;
            const vm = ko.dataFor($('#moods-chart')[0]);

            vm.showDetailMoods(cat);

            for (const yAxis of overViewChart.yAxes) {
                for (const di of yAxis.dataItems) {

                    if (di.label.background) {
                        di.label.background.fill = am4core.color('white');
                    }
                }
            }

            e.target.background.fill = am4core.color('yellow');
        });
        let label = yAxis.renderer.labels.template;
        label.wrap = true;
        label.maxWidth = 180;

        yAxis.renderer.inversed = true;

        var image = new am4core.Image();
        image.horizontalCenter = "middle";
        image.width = 30;
        image.height = 30;
        image.verticalCenter = "middle";
        image.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        image.adapter.add("href", (href, target) => {
            let category = target.dataItem.category;

            if (typeof category != 'undefined') {
                return '/assets/moods_colors/' + category + '.svg';
            }

            return href;
        });
        xAxis.dataItems.template.bullet = image;
        xAxis.renderer.labels.template.disabled = true;

        var series = overViewChart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryY = "feature";
        series.dataFields.categoryX = "rating";
        series.dataFields.customValue = "rating";
        series.dataFields.value = "percentageOfTotalBiased";
        series.columns.template.disabled = true;
        series.sequencedInterpolation = true;
        series.maskBullets = false;
        //series.defaultState.transitionDuration = 3000;

        var bullet = series.bullets.push(new am4core.Circle());
        bullet.tooltipText = "{feature}: {percentageOfTotal.formatNumber('#.##%')} of {tagsSumCount} responses";
        //bullet.strokeWidth = 3;
        bullet.stroke = am4core.color("#ffffff");
        //bullet.strokeOpacity = 0;
        bullet.strokeOpacity = 1;
        bullet.strokeWidth = 2;
        //bullet.fillOpacity = 0.7;

        bullet.adapter.add("fill", function (fill, target) {
            if (target.dataItem) {
                if (target.dataItem.customValue >= 10) {
                    return am4core.color("#a8df65")
                }
                else if (target.dataItem.customValue >= 7) {
                    return am4core.color("#f6f578")
                }
                else if (target.dataItem.customValue >= 5) {
                    return am4core.color("#fbe555")
                }
                else if (target.dataItem.customValue >= 3) {
                    return am4core.color("#f8b500")
                }
                else {
                    return am4core.color("#eb4559");
                }
            }
            return fill;
        });

        var hoverState = bullet.states.create("hover");
        hoverState.properties.fillOpacity = 1;
        //hoverState.properties.strokeOpacity = 1;

        series.heatRules.push({
            property: "radius",
            target: bullet,
            min: 8,
            max: 30
        });

        bullet.hiddenState.properties.scale = 0.01;
        bullet.hiddenState.properties.opacity = 1;

        var hoverState = bullet.states.create("hover");
        hoverState.properties.strokeOpacity = 1;

        document.addEventListener('refresh_chart_overview', (e) => {
            //overViewChart.data = e.detail.sort((a, b) => (a.rating > b.rating) ? 1 : -1);
            selectDataset(e.detail.sort((a, b) => (a.rating > b.rating) ? 1 : -1));
        });

        function selectDataset(data) {
            overViewChart.invalidateRawData();
            overViewChart.data = data;
            series.appear();
        }
    }
}